import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Modal, Text, TextInput } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import Box from '@/components/ui/Box'
import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function ProfileAccountActions({ profile, onMutate }) {
    const { requestPatch, requestDelete } = useAxiosApi()
    const navigate = useNavigate()
    const [action, setAction] = useState(null)
    const [confirmation, setConfirmation] = useState('')
    const [saving, setSaving] = useState(false)
    const expectedConfirmation = profile.name || profile.email || profile.id

    const submit = async () => {
        setSaving(true)
        try {
            if (action === 'delete') {
                await requestDelete(`/profiles/${profile.id}`, { confirmation: profile.id })
                notifications.show({ message: 'Compte supprimé', color: 'green' })
                navigate('/profiles')
            } else {
                await requestPatch(`/profiles/${profile.id}/status`, { disabled: !profile.disabled })
                notifications.show({ message: profile.disabled ? 'Accès réactivé' : 'Accès suspendu', color: 'green' })
                await onMutate?.()
            }
            setAction(null)
        } catch {
            // API errors are displayed by useAxiosApi.
        } finally {
            setSaving(false)
        }
    }

    return (
        <>
            <Box title="Accès au compte">
                <div className="flex flex-col gap-3">
                    <Text size="sm">{profile.disabled ? 'Ce compte est suspendu.' : 'Ce compte est actif.'}</Text>
                    <Button variant="light" color={profile.disabled ? 'green' : 'orange'} onClick={() => setAction('status')}>
                        {profile.disabled ? 'Réactiver l’accès' : 'Suspendre l’accès'}
                    </Button>
                    <Button variant="light" color="red" onClick={() => { setConfirmation(''); setAction('delete') }}>
                        Supprimer le compte
                    </Button>
                </div>
            </Box>
            <Modal opened={action !== null} onClose={() => !saving && setAction(null)}
                title={action === 'delete' ? 'Supprimer définitivement le compte' : profile.disabled ? 'Réactiver l’accès' : 'Suspendre l’accès'}>
                <div className="flex flex-col gap-4">
                    {action === 'delete' ? (
                        <>
                            <Text size="sm">
                                Le compte de connexion, le profil, les clés d’accès et les préférences seront supprimés.
                                Les opérations et commentaires seront conservés avec un auteur supprimé ou sans auteur.
                                Cette action est irréversible ; elle ne supprime pas le contenu personnel éventuellement présent dans les textes ou documents.
                            </Text>
                            <TextInput label={`Saisir « ${expectedConfirmation} » pour confirmer`}
                                value={confirmation} onChange={(event) => setConfirmation(event.target.value)} autoFocus />
                        </>
                    ) : (
                        <Text size="sm">{profile.disabled
                            ? 'La personne pourra à nouveau se connecter avec ses moyens de connexion existants.'
                            : 'L’accès à l’API sera refusé dès la prochaine requête, y compris pour une session déjà ouverte. L’historique sera conservé.'}</Text>
                    )}
                    <Button color={action === 'delete' ? 'red' : profile.disabled ? 'green' : 'orange'}
                        loading={saving} disabled={action === 'delete' && confirmation !== expectedConfirmation} onClick={submit}>
                        {action === 'delete' ? 'Supprimer définitivement' : 'Confirmer'}
                    </Button>
                </div>
            </Modal>
        </>
    )
}
